import { IExcursionProduct } from "interfaces/Musement/IExcursionProduct";
import { getAgeRangeFromMusementProductName } from "utils/getAgeRangeFromMusementProductName";

const TYPE_ADULT = "ADULT";

const TYPE_CHILDREN = "CHILDREN";

const TYPE_BABY = "INFANT";

type Props = {
  products?: IExcursionProduct[];
};

export const useGetExcursionProductsAgeRanges = ({ products }: Props) => {
  const adultProduct = products?.find(
    (product: IExcursionProduct) =>
      product.holder_code_normalized === TYPE_ADULT
  );

  const childProduct = products?.find(
    (product: IExcursionProduct) =>
      product.holder_code_normalized === TYPE_CHILDREN
  );

  const babyProduct = products?.find(
    (product: IExcursionProduct) => product.holder_code_normalized === TYPE_BABY
  );

  const adultAgeRange = getAgeRangeFromMusementProductName(adultProduct?.name);
  const childAgeRange = getAgeRangeFromMusementProductName(childProduct?.name);
  const babyAgeRange = getAgeRangeFromMusementProductName(babyProduct?.name);

  return { adultAgeRange, childAgeRange, babyAgeRange };
};
